export const update = (name: string, value: any) => ({
  type: 'UI_SETTING_UPDATE' as const,
  name,
  value
});

export const setGptConnects = (value: number) => ({
  type: 'UI_SETTING_SET_GPT_CONNECTS' as const,
  value
});
